import React, { useState } from 'react';
import { SlideLayout } from '../components/SlideLayout';
import { Button } from '../components/Button';
import { PlayIcon, ArrowLeft, X } from 'lucide-react';
interface Slide12Props {
  onBack: () => void;
}
export function Slide12({
  onBack
}: Slide12Props) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <SlideLayout footer="¹ Vabysmo® Summary of Product Characteristics (SmPC/RCP), May 2024." progress={{
    current: 1,
    total: 1
  }} onBack={onBack} data-id="element-65">
      <div className="w-full max-w-7xl mx-auto grid grid-cols-5 gap-8 items-center" data-id="element-66">
        <div className="col-span-3 space-y-3" data-id="element-67">
          <h1 className="text-2xl font-bold text-primary mb-2" data-id="element-68">
            Double inhibition
          </h1>
          <div className="space-y-3" data-id="element-69">
            <p className="text-base text-gray-700 leading-snug" data-id="element-70">
              By inhibiting both VEGF-A and Ang-2, faricimab:<sup data-id="element-71">¹</sup>
            </p>
            <ul className="space-y-1 text-base text-gray-700 pl-6" data-id="element-72">
              <li className="flex items-start" data-id="element-73">
                <span className="text-accent mr-3" data-id="element-74">•</span>
                <span data-id="element-75">Reduces vascular permeability</span>
              </li>
              <li className="flex items-start" data-id="element-76">
                <span className="text-accent mr-3" data-id="element-77">•</span>
                <span data-id="element-78">Reduces inflammation</span>
              </li>
              <li className="flex items-start" data-id="element-79">
                <span className="text-accent mr-3" data-id="element-80">•</span>
                <span data-id="element-81">Inhibits pathological angiogenesis</span>
              </li>
              <li className="flex items-start" data-id="element-82">
                <span className="text-accent mr-3" data-id="element-83">•</span>
                <span data-id="element-84">Helps restore vascular stability</span>
              </li>
            </ul>
          </div>
          <div className="pt-2" data-id="element-85">
            <Button variant="primary" onClick={onBack} data-id="element-86">
              <ArrowLeft className="w-5 h-5" data-id="element-87" />
              Back to menu
            </Button>
          </div>
        </div>
        <div className="col-span-2 flex items-center justify-center" data-id="element-88">
          <button onClick={() => setIsModalOpen(true)} className="w-full aspect-video rounded-xl shadow-2xl flex items-center justify-center relative overflow-hidden cursor-pointer hover:opacity-90 transition-opacity" type="button" data-id="element-89">
            {/* Background Image */}
            <img src="https://cdn.magicpatterns.com/uploads/7zbxHPJqTr6AEKXahx5AQh/Screenshot_2026-02-16_at_15.47.04.png" alt="VEGF-A and ANG-2 visualization" className="absolute inset-0 w-full h-full object-cover" data-id="element-90" />
            {/* Text Overlay */}
            <div className="absolute inset-0 bg-black bg-opacity-40 flex flex-col items-center justify-center space-y-4" data-id="element-91">
              <PlayIcon className="w-16 h-16 text-white opacity-80" data-id="element-92" />
              <div className="text-white text-center" data-id="element-93">
                <p className="text-base font-semibold" data-id="element-94">Want to see more?</p>
              </div>
            </div>
          </button>
        </div>
      </div>

      {/* Modal Popup */}
      {isModalOpen && <div className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center z-50" onClick={() => setIsModalOpen(false)} data-id="element-95">
          <div className="relative bg-white rounded-2xl shadow-2xl max-w-[50vw] max-h-[50vh] w-[50vw] overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-96">
            {/* Close Button */}
            <button onClick={() => setIsModalOpen(false)} className="absolute top-4 right-4 z-10 bg-white rounded-full p-2 hover:bg-gray-100 transition-colors shadow-lg" type="button" data-id="element-97">
              <X className="w-6 h-6 text-gray-700" data-id="element-98" />
            </button>
            {/* Modal Content */}
            <div className="w-full h-full" data-id="element-99">
              <img src="https://cdn.magicpatterns.com/uploads/7zbxHPJqTr6AEKXahx5AQh/Screenshot_2026-02-16_at_15.47.04.png" alt="VEGF-A and ANG-2 visualization - Full view" className="w-full h-full object-contain" data-id="element-100" />
            </div>
          </div>
        </div>}
    </SlideLayout>;
}